export interface FigureVarData {
  varName: string;
  value: string;
}

/**
 * Type guard to check if an object is a FigureVarData
 *
 * @param obj - The object to check
 * @returns - true if the object is a FigureVarData
 */
export const isFigureVarData = (obj: unknown): obj is FigureVarData => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureVarData;
  if (typeof chkObj.varName !== "string") {
    return false;
  }
  if (typeof chkObj.value !== "string") {
    return false;
  }
  return true;
};
